/* Black Friday launch - the lock on /pages/black-friday (sections/bf-lock.liquid).

   The inline script in the section has already decided whether the lock is up
   (window.bfLock). This file does the rest:
   - the countdown to 19:00;
   - the code form. Only the SHA-256 of the code is in the page. Before 19:00 a right code
     only says "you are early"; after that it is remembered on the device and opens the page;
   - the moments. On the locked template the page reloads after 19:00 until Erik has switched
     it to the deal builder, so nobody stays on a locked page. At 00:00 the lock goes and the
     page reloads, so the deal sections set themselves up while visible;
   - ?code= in a link (mail, WhatsApp) fills in the code and submits it.

   With ?preview_date= nothing reloads and nothing is stored, so a preview cannot lock or
   unlock the real page. */
(function () {
  'use strict';

  var S = window.bfLock;
  if (!S || !S.root) return;

  var root = S.root;
  var RELOAD_KEY = 'cp-bf-lock-reload';
  var form = root.querySelector('[data-bflock-form]');
  var input = form && form.querySelector('input');
  var msg = root.querySelector('[data-bflock-msg]');
  var clock = root.querySelector('[data-bflock-clock]');
  var phase = S.phase();

  function track(result) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'bf_lock_code', bf_lock_result: result, bf_lock_phase: S.phase() });
  }

  function say(key, tone) {
    if (!msg || !form) return;
    msg.textContent = form.getAttribute('data-msg-' + key) || '';
    msg.setAttribute('data-tone', tone || 'error');
    msg.hidden = false;
  }

  function remember() {
    try {
      localStorage.setItem(S.key, S.hash);
    } catch (e) {
      try {
        sessionStorage.setItem(S.key, S.hash);
      } catch (e2) {}
    }
  }

  // A reload, at most once per 45 seconds per tab, so a page that has not been switched yet
  // does not reload in a loop.
  function reload() {
    if (S.preview) return;
    var last = 0;
    try {
      last = parseInt(sessionStorage.getItem(RELOAD_KEY), 10) || 0;
    } catch (e) {}
    if (Date.now() - last < 45000) return;
    try {
      sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
    } catch (e) {}
    location.reload();
  }

  function cleanUrl() {
    var url = new URL(location.href);
    if (!url.searchParams.has('code')) return;
    url.searchParams.delete('code');
    if (window.history && history.replaceState) {
      history.replaceState(history.state, '', url.toString());
    }
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function renderClock() {
    if (!clock) return;
    var left = Math.max(0, Math.floor((S.live - S.now()) / 1000));
    var days = Math.floor(left / 86400);
    var set = function (unit, value) {
      var el = clock.querySelector('[data-unit="' + unit + '"]');
      if (el) el.textContent = pad(value);
    };
    var dayWrap = clock.querySelector('[data-unit-wrap="days"]');
    if (dayWrap) dayWrap.hidden = days === 0;
    set('days', days);
    set('hours', Math.floor((left % 86400) / 3600));
    set('minutes', Math.floor((left % 3600) / 60));
    set('seconds', left % 60);
  }

  // Called every second.
  var spread = Math.random() * 15000;
  function tick() {
    var now = S.phase();
    if (now === 'early') {
      renderClock();
      // Locked template after 19:00: Erik switches by hand, so keep looking for the switch.
      // The spread keeps every open tab from reloading in the same second.
      if (S.mode === 'locked' && S.now() >= S.live + spread) reload();
    }
    if (now === phase) return;
    var wasLocked = !root.hidden;
    phase = now;

    // 00:00: start clean, so the deal sections set themselves up in view.
    if (now === 'off' && wasLocked && !S.preview) {
      location.reload();
      return;
    }
    S.apply();
  }

  function sha256(text) {
    var bytes = new TextEncoder().encode(text);
    return crypto.subtle.digest('SHA-256', bytes).then(function (buf) {
      return Array.prototype.map
        .call(new Uint8Array(buf), function (b) {
          return ('0' + b.toString(16)).slice(-2);
        })
        .join('');
    });
  }

  function check(raw) {
    var code = String(raw || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    if (!code) {
      say('empty');
      return;
    }
    if (!window.crypto || !crypto.subtle || !window.TextEncoder) {
      say('wrong');
      return;
    }

    sha256(code).then(function (hash) {
      if (hash !== S.hash) {
        say('wrong');
        track('wrong');
        return;
      }

      var now = S.phase();
      if (now === 'early' && S.now() < S.live) {
        say('early', 'info');
        track('early');
        return;
      }

      track('unlock');
      if (S.preview) {
        root.hidden = true;
        document.documentElement.classList.remove('bflock-on');
        return;
      }

      remember();
      say('ok', 'info');
      // Reload so the deal sections, set up while hidden, start again in view. On the locked
      // template after 19:00 this also picks up the switch to the deal builder.
      try {
        sessionStorage.removeItem(RELOAD_KEY);
      } catch (e) {}
      location.reload();
    });
  }

  if (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (msg) msg.hidden = true;
      check(input && input.value);
    });
  }

  var linked = new URLSearchParams(location.search).get('code');
  cleanUrl();
  if (linked && input && !root.hidden) {
    input.value = linked;
    check(linked);
  }

  renderClock();
  setInterval(tick, 1000);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) tick();
  });
})();
